/* global axios */

import ApiClient from './ApiClient';

class InboxContactDataSourceAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}/contact_data_source`);
  }

  update(inboxId, contactDataSource) {
    return axios.put(`${this.url}/${inboxId}/contact_data_source`, {
      contact_data_source: contactDataSource,
    });
  }
}

export default new InboxContactDataSourceAPI();
